module.exports = __webpack_public_path__ + "assets/成交金额.a6b0d856.svg";